import type { AuthorizedResourceAccessMap } from '@/permissions/adapter';

/**
 * @see https://umijs.org/docs/max/access#access
 * */
export default function access(
  initialState:
    | {
        authorizedResourceAccess?: AuthorizedResourceAccessMap;
        currentTenantIsAdmin?: boolean;
      }
    | undefined,
) {
  const { authorizedResourceAccess, currentTenantIsAdmin } = initialState ?? {};

  if (currentTenantIsAdmin) {
    return new Proxy(
      { ...(authorizedResourceAccess ?? {}) } as AuthorizedResourceAccessMap,
      {
        get(target, prop: string | symbol) {
          if (typeof prop === 'symbol') {
            return Reflect.get(target, prop);
          }

          return target[prop] ?? true;
        },
      },
    );
  }

  return {
    ...(authorizedResourceAccess ?? {}),
  };
}
